import { useEffect } from 'react';

const CSS_VAR_NAME = '--vv-height';

function setViewportHeightVar(viewport: VisualViewport) {
  document.documentElement.style.setProperty(CSS_VAR_NAME, `${viewport.height}px`);
}

export function useVisualViewportHeight(): void {
  useEffect(() => {
    const viewport = window.visualViewport;

    if (!viewport) {
      return;
    }

    const handleViewportChange = () => setViewportHeightVar(viewport);

    handleViewportChange();

    viewport.addEventListener('resize', handleViewportChange);
    viewport.addEventListener('scroll', handleViewportChange);

    return () => {
      viewport.removeEventListener('resize', handleViewportChange);
      viewport.removeEventListener('scroll', handleViewportChange);
    };
  }, []);
}
